import { observer } from 'mobx-react-lite'
import { InventoryItemFormContainer } from '@/features/inventory/admin/components/InventoryItemForm/InventoryItemFormContainer'
import { InventoryItemFormWorkspaceDropdownContainer } from '@/features/inventory/admin/components/InventoryItemFormWorkspaceDropdown/InventoryItemFormWorkspaceDropdownContainer'
import { type OverrideInventoryItemDialogViewModel } from './OverrideInventoryItemDialogViewModel'

export interface OverrideInventoryItemDialogContainerProps {
  vm: OverrideInventoryItemDialogViewModel
}

export const OverrideInventoryItemDialogContainer = observer(
  function OverrideInventoryItemDialogContainer({
    vm,
  }: OverrideInventoryItemDialogContainerProps) {
    return (
      <InventoryItemFormContainer
        title="Override service item"
        submitText="Override"
        overridden={true}
        vm={vm}
      >
        {vm.canSelectWorkspace && (
          <InventoryItemFormWorkspaceDropdownContainer vm={vm} />
        )}
      </InventoryItemFormContainer>
    )
  },
)
